// Primary entry — the Container (selects the roster per program.target, wires
// navigation, and renders the View). ProgramDetail imports this as
// `QualifiedUsers`, unchanged (same `program` prop).
export { QualifiedUsersContainer as QualifiedUsers } from "./QualifiedUsersContainer";
// The props-only View — for the sim (renders with fixture participants, no
// mock reads, no router). Never imported by ProgramDetail.
export { QualifiedUsers as QualifiedUsersView, type QualifiedUsersProps } from "./QualifiedUsers";
